// extracted by mini-css-extract-plugin
export var modalFooter = "_sj-0";